import React from "react";
import particelsConfig from "../config/particle-config";
import Particles from "react-tsparticles";

const ParticlesBackground = () => {
	return (
		<Particles
			params={particelsConfig}
			style={{
				zIndex: "-9999",
			}}
		></Particles>
	);
};

export default ParticlesBackground;
